const QUESTION_START = /^(what|why|how|when|where|who|which|can|could|would|should|does|do|is|are)\b/i;
const EXPLANATION_PHRASE = /\b(what do you mean|explain|meaning of|tell me about|help me understand)\b/i;
const CONTROL_ID = /^[A-Z]{1,5}(?:[.-][A-Z0-9]+){1,5}$/i;

export const shouldEscalateSearchToAI = (query) => {
    const normalized = String(query || '').trim();
    if (!normalized || CONTROL_ID.test(normalized)) return false;

    const wordCount = normalized.split(/\s+/).length;
    return QUESTION_START.test(normalized) ||
        EXPLANATION_PHRASE.test(normalized) ||
        normalized.includes('?') ||
        wordCount > 6;
};
